// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"d66c1588","453":"0471fc82"}[chunkId] + ".chunk.js";
};